import {useCallback} from "react";
import ReduxFetchState from "redux-fetch-state";
import {put, takeEvery} from "redux-saga/effects";
import axios from "../../../../Utils/axiosConfig";
import {getCurrentLanguage} from "../../../../Utils/sagaHelpers";
import {useAppDispatch, useAppSelector} from "../../../../Hooks/useStore";
import {alert} from "../../../../Utils/toast";
import {FeedbackResponseTypes} from "../../../../Schema/getFeedbacks.types";

export type GetFeedbacksPayload = {
    categoryId: number | string;
    page: number | string | null;
};

export type GetFeedbacksLoadAction = {
    type: string;
    payload: GetFeedbacksPayload;
};

export type GetFeedbacksData = {
    data:FeedbackResponseTypes;
};


const GetFeedbacks = new ReduxFetchState<GetFeedbacksData, GetFeedbacksPayload, any>(
    "getFeedbacks",
);

export function* watchGetFeedbacks(action: GetFeedbacksLoadAction) {
    try {
        const lang: "fa" | "en" = yield getCurrentLanguage();
        const {categoryId,page} = action.payload;

        const data: GetFeedbacksData = yield axios({
            url: `/api/v1/ai/service/${categoryId}/feedbacks?page=${page}`,
            method: "GET",
            headers: {lang}
        });
        yield put(GetFeedbacks.actions.loadSuccess({data: data.data}));
    } catch (e: any) {
        const backendError = e?.response?.data?.error || e?.message || "Something went wrong";
        alert({message: backendError, type: "error"});
        yield put(GetFeedbacks.actions.loadFailure(e.message));
    }
}

export function* getFeedbacksSagas() {
    yield takeEvery(GetFeedbacks.actionTypes.load, watchGetFeedbacks);
}

export function useGetFeedbacks() {
    const {loading, data, ...getFeedbacksState} = useAppSelector(
        (state) => state.getFeedbacks,
    );
    const dispatch = useAppDispatch();

    const dispatchGetFeedbacks = useCallback(
        (data: GetFeedbacksPayload) => {
            dispatch(GetFeedbacks.actions.load(data));
        },
        [dispatch],
    );

    return {
        ...getFeedbacksState,
        dispatchGetFeedbacks,
        getFeedbacksLoading: loading,
        getFeedbacksData: data,
    };
}

export const {
    actionTypes: getFeedbacksActionsTypes,
    actions: getFeedbacksActions,
    reducer: getFeedbacksReducer,
} = GetFeedbacks;